var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, reaction } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { NOT_LOADED } from "../Infra/RemoteData";
import { UserType } from "healthex-common/user.dtos";
export class ResetPasswordUIManager {
    constructor(routingUIManager, authManager, provisioningService) {
        this.routingUIManager = routingUIManager;
        this.authManager = authManager;
        this.provisioningService = provisioningService;
        this.authenticatedUser = NOT_LOADED;
        this.organization = NOT_LOADED;
        this.resetPasswordToken = null;
        reaction(() => routingUIManager.currentRoute, async (currentRoute) => {
            if ((currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.routeName) === NamedRoutes.RESET_PASSWORD.routeName) {
                await this.authenticateUser();
                await this.getOrganization();
            }
        });
    }
    async authenticateUser() {
        var _a, _b;
        this.resetPasswordToken = (_b = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.resetPasswordToken) !== null && _b !== void 0 ? _b : null;
        if (!this.resetPasswordToken) {
            this.authenticatedUser = null;
            return;
        }
        try {
            this.authenticatedUser = await this.authManager.authenticateByToken(this.resetPasswordToken);
        }
        catch {
            this.authenticatedUser = null;
        }
    }
    async getOrganization() {
        if (this.authenticatedUser === NOT_LOADED || this.authenticatedUser === null)
            return;
        if (this.authenticatedUser.type === UserType.PATIENT || this.authenticatedUser.type === UserType.PATIENT_READ_ONLY) {
            this.organization = null;
            return;
        }
        try {
            this.organization = await this.provisioningService.getOrganizationPublicProfileById(this.authenticatedUser.organizationId);
        }
        catch {
            this.organization = null;
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ResetPasswordUIManager.prototype, "authenticatedUser", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ResetPasswordUIManager.prototype, "organization", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ResetPasswordUIManager.prototype, "resetPasswordToken", void 0);
